<template>
  <div>
    <v-select
      v-if="!isLoading"
      :items="items"
      v-model="model"
      label="Tax Rate"
      item-text="displayName"
      item-value="id"
      :disabled="isDisabled"
      :rules="rules"
    >
      <template v-slot:append-item v-if="locationId">
        <v-divider class="mb-2"></v-divider>
        <v-list-item @click="newItem()">
          <v-list-item-avatar color="grey lighten-3">
            <v-icon>mdi-plus</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Add custom tax rate</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: [],
      formOpen: false
    };
  },
  props: {
    value:{
      type: Number,
    },
    locationId:{
      type:Number,
    },
    disabled:{
      type:Boolean,
      default: () => false
    },
    rules:{
      type:Array
    },
  },
  computed: {
    isDisabled() {
      return this.disabled 
    },
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    getList() {
      this.$store
        .dispatch("taxRates/index", {
          locationId: this.locationId
        })
        .then(data => {
          this.items = data.datas;
        })
        .finally(() => (this.isLoading = false));
    },

    addItem(data) {
      this.getList();
      this.model = data.id;
    },
    newItem() {
      this.formOpen = true;
    }
  }
};
</script>
